/**
 * True when the app is being served from the developer's own machine
 * (`localhost` or `127.0.0.1`). Used to opt in to dev-only conveniences
 * — e.g. forcing certain feature flags on — without affecting the
 * deployed dev / staging / prod environments, which all serve from
 * real hostnames.
 */
export function isLocalhost(): boolean {
	if (typeof window === 'undefined') return false;
	const host = window.location.hostname;
	return host === 'localhost' || host === '127.0.0.1';
}
